import * as S from './styles'

import { Link, useHistory, useParams } from 'react-router-dom'
import { capitalizePhrase, convertDecimalCurrency } from '../../utils/utils'
import OperationCardPrint from '../OperationCardPrint'
import { useRef, useState } from 'react'

import { getPedidoStatusColor } from '../FichaPedido/utils'

import Table from '../Table'
import ToastCotacao from '../ToastCotacao'
import { dateFromString } from '../Filter/masks'
import { timeFromString } from '../DadosCadastroPF/masks'
import {
  getStatusNegociacao,
  isVencidaOrComPedido
} from '../OperationCard/utils'
import { useReactToPrint } from 'react-to-print'
import IconPrint from '../../assets/img/icon-print-white.svg'
import IconPDF from '../../assets/img/icon-download.svg'
import IconRefresh from '../../assets/img/icon-refresh.svg'
import { changePagamentoMessage } from './utils'
import MediaMatch from '../MediaMatch'

const NegociacaoDetalhe = ({ pedidoFilter }) => {
  const params = useParams()
  const history = useHistory()

  const [printIndex, setPrintIndex] = useState(0)

  const printRef = useRef([])

  const handlePrint = useReactToPrint({
    content: () => printRef.current[printIndex]
  })

  const filiais = (input) => {
    const ids = new Set()

    return input
      ?.map((e) => ({ filial: e.Filial, id: e.IdFilial }))
      .filter((e) => {
        if (ids.has(e.id)) {
          return false
        }

        ids.add(e.id)
        return true
      })
  }

  const negociacaoItem = pedidoFilter?.Data?.filter(
    (negociacao) => negociacao.Id === parseInt(params.idNegociacao)
  )

  return (
    <>
      {negociacaoItem?.length === 0
        ? history.push('/negociacoes')
        : negociacaoItem?.map((negociacao, index) => {
            return (
              <S.Wrapper key={index}>
                <S.DetailsHead>
                  <S.DetailsWrapper className="card">
                    <h3>Detalhes da Negociação</h3>

                    <p>
                      <strong>Negociação nº: </strong> {negociacao?.Id}
                    </p>
                    <p>
                      <strong>Validade: </strong>{' '}
                      {dateFromString(negociacao?.DataValidade)} às{' '}
                      {timeFromString(negociacao?.DataValidade)}
                      {negociacao?.Expirado && ' - Vencida'}
                    </p>
                    <p>
                      <strong>Data: </strong>{' '}
                      {dateFromString(negociacao?.DataRequisicao)} às{' '}
                      {timeFromString(negociacao?.DataRequisicao)}
                    </p>

                    <p className="status">
                      <strong>Status Atual: </strong>{' '}
                      <S.Tag
                        color={getPedidoStatusColor(
                          negociacao?.DescricaoSituacao
                        )}
                        type={getStatusNegociacao(negociacao)}
                      >
                        {getStatusNegociacao(negociacao)}
                      </S.Tag>
                    </p>

                    <p>
                      <strong>Produtos: </strong>{' '}
                      {negociacao?.ValorProdutos === 0
                        ? convertDecimalCurrency(negociacao?.ValorTotal)
                        : convertDecimalCurrency(negociacao?.ValorProdutos)}
                    </p>
                    {!negociacao.PossuiIPI ? null : (
                      <p>
                        <strong>IPI: </strong>{' '}
                        {convertDecimalCurrency(negociacao?.ValorTotalIPI)}
                      </p>
                    )}

                    <p>
                      <strong>Frete: </strong>{' '}
                      {negociacao?.ValorFrete === 0
                        ? 'Grátis'
                        : convertDecimalCurrency(negociacao?.ValorFrete)}
                    </p>

                    {negociacao?.ValorAcrescimoFinanceiro === 0 ? null : (
                      <p>
                        <strong>Acréscimo Financeiro: </strong>{' '}
                        {convertDecimalCurrency(
                          negociacao?.ValorAcrescimoFinanceiro
                        )}
                      </p>
                    )}

                    {negociacao?.ValorSubstituicaoTributaria === 0 ? null : (
                      <p>
                        <strong>ICMS-ST: </strong>{' '}
                        {convertDecimalCurrency(
                          negociacao?.ValorSubstituicaoTributaria
                        )}
                      </p>
                    )}

                    {negociacao?.DetalhePagamento?.DescontoFormaPagamento ===
                    0 ? null : (
                      <p>
                        <strong>Desconto Pagamento: </strong>{' '}
                        {convertDecimalCurrency(
                          negociacao?.DetalhePagamento?.DescontoFormaPagamento
                        )}
                      </p>
                    )}

                    {negociacao?.ValorDescontoGimplus === 0 ? null : (
                      <p>
                        <strong>Desconto Gimplus: </strong>{' '}
                        {convertDecimalCurrency(
                          negociacao?.ValorDescontoGimplus
                        )}
                      </p>
                    )}

                    {negociacao?.CupomDesconto !== null && (
                      <p>
                        <strong>Cupom Desconto: </strong>{' '}
                        {convertDecimalCurrency(negociacao?.ValorCupomDesconto)}
                      </p>
                    )}

                    {/* {negociacao?.ValorDesconto === 0 ? null : (
                      <p>
                        <strong>Valor do Desconto Total: </strong>{' '}
                        {convertDecimalCurrency(negociacao?.ValorDesconto)}
                      </p>
                    )} */}

                    <p>
                      <strong>Valor Total : </strong>
                      {convertDecimalCurrency(negociacao?.ValorTotal)}
                    </p>
                  </S.DetailsWrapper>

                  <S.AddressPaymentWrapper>
                    <S.AddressPaymentItem className="card">
                      <h3>Detalhes do Pagamento</h3>

                      <p>
                        <strong>Forma de Pagamento: </strong>{' '}
                        {negociacao?.DetalhePagamento?.DescricaoFormaPagamento}
                      </p>

                      <p>
                        <strong>Condição de Pagamento: </strong>{' '}
                        {changePagamentoMessage(negociacao)}
                      </p>

                      {/* <p>
                        <strong>Condição de Pagamento: </strong>{' '}
                        {
                          negociacao?.DetalhePagamento
                            .DescricaoCondicaoPagamento
                        }
                      </p>

                      <p>
                        <strong>Juros: </strong>{' '}
                        {negociacao?.DetalhePagamento.Juros}
                      </p> */}
                    </S.AddressPaymentItem>

                    <S.AddressPaymentItem className="card">
                      <h3>Detalhes da Entrega</h3>

                      <p>
                        <strong>Endereço de Entrega: </strong>
                        {capitalizePhrase(
                          negociacao?.EnderecoEntrega?.Endereco
                        )}
                        , {negociacao?.EnderecoEntrega?.Numero} -{' '}
                        {capitalizePhrase(negociacao?.EnderecoEntrega?.Bairro)}{' '}
                        -{' '}
                        {capitalizePhrase(negociacao?.EnderecoEntrega?.Cidade)}/
                        {negociacao?.EnderecoEntrega?.UF} -{' '}
                        {negociacao?.EnderecoEntrega?.CEP.replace(
                          /^([\d]{2})*([\d]{3})-*([\d]{3})/,
                          '$1$2-$3'
                        )}
                      </p>

                      <p>
                        <strong>Endereço de Faturamento: </strong>
                        {capitalizePhrase(
                          negociacao?.EnderecoFaturamento?.Endereco
                        )}
                        , {negociacao?.EnderecoFaturamento?.Numero} -{' '}
                        {capitalizePhrase(
                          negociacao?.EnderecoFaturamento?.Bairro
                        )}{' '}
                        -{' '}
                        {capitalizePhrase(
                          negociacao?.EnderecoFaturamento?.Cidade
                        )}
                        /{negociacao?.EnderecoFaturamento?.UF} -{' '}
                        {negociacao?.EnderecoFaturamento?.CEP.replace(
                          /^([\d]{2})*([\d]{3})-*([\d]{3})/,
                          '$1$2-$3'
                        )}
                      </p>
                    </S.AddressPaymentItem>
                  </S.AddressPaymentWrapper>
                </S.DetailsHead>

                {negociacao?.DescricaoSituacao === 'Negociação Avaliada' && (
                  <ToastCotacao message="Estes são os melhores preços que conseguimos negociar." />
                )}

                <Table
                  products={negociacao?.Itens}
                  type="n"
                  filiais={filiais}
                ></Table>

                <div
                  className="to-print"
                  ref={(ref) => printRef.current.push(ref)}
                >
                  <OperationCardPrint
                    item={negociacao}
                    type="n"
                  ></OperationCardPrint>
                </div>
                {!isVencidaOrComPedido('n', negociacao) ||
                  (getStatusNegociacao(negociacao) !== 'Em Avaliação' && (
                    <S.DetailsFooter>
                      <S.Button
                        onClick={() => {
                          handlePrint()
                        }}
                      >
                        <img src={IconPrint} alt="Imprimir Negociação" />
                        Imprimir
                      </S.Button>

                      <S.Button
                        className="outline-red"
                        onClick={() => {
                          handlePrint()
                        }}
                      >
                        <img src={IconPDF} alt="Gerar PDF" />
                        Gerar PDF
                      </S.Button>
                    </S.DetailsFooter>
                  ))}
                <S.DetailsFooter>
                  <a
                    href={`${process.env.REACT_APP_URL_MAIN}/negociacoes/RefazerNegociacao/?idNegociacao=${negociacao?.Id}`}
                  >
                    <S.Button className="green">
                      <img src={IconRefresh} alt="Ícone refazer pedido" />
                      Refazer Negociação
                    </S.Button>
                  </a>

                  <Link to="/negociacoes">
                    <S.Button className="outline">Voltar</S.Button>
                  </Link>
                </S.DetailsFooter>
              </S.Wrapper>
            )
          })}
    </>
  )
}

export default NegociacaoDetalhe
